import React from "react";
import Fonts from "../../../../stories/assets/Fonts";
import Colors from "../../../../stories/assets/Colors";
import ModalSkeleton from "../../../ModalSkeleton/ModalSkeleton";
import { Button } from "../../../../stories/Button/Button";
import { Modal } from "react-bootstrap";
import classes from "./BanExplanationModal.module.css";
import { starIconss } from "../../../../constant/imagePath";
import { LinkButtonWithIcon } from "../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";

const BanExplanationModal = ({ show, setShow }) => {
  return (
    <>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        borderRadius={"20px"}
        width={"468px"}
        height={"188px"}
        padding={"32px"}
        showCloseIcon={true}
        footer={<div className={classes.btnsBox}>
          <LinkButtonWithIcon
            primary={true}
            text="Cancel"
            customStyle={{ color: Colors.neutralShadesOfNero, marginRight: '48px' }}
            onClick={() => setShow(false)}
          />
          <Button
            size="Medium"
            label="Ban"
            primary={true}
            customStyle={{
              width: "max-content",
              padding: '14px 47px'
            }}
            onClick={() => setShow(false)}
          />
        </div>
        }
      >
        <div className={classes.modalContent}>
          <h4 style={{ ...Fonts.h4, color: Colors.neutralShadesOfNero }}>
            Ban explanation message to: John Johnson
          </h4>
          <div className={classes.rating}>
            <img src={starIconss} alt="starIconsss" />
            <h6
              style={{
                ...Fonts.h7,
                color: Colors.neutralShadesOfNero,
                margin: "15px 0",
              }}
            >
              5.0
            </h6>
          </div>
          <p style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}>
            Cancellations: 3
          </p>
          <div className={classes.wrapperTextarea}>
            <p style={{ ...Fonts.p1, color: Colors.neutralShadesOfNero }}>
              Reason
            </p>
            <textarea
              name="modal"
              className={classes.custumTextArea}
            ></textarea>
          </div>
          {/* <Modal.Footer> */}
          <div className={classes.CustommodalFooter}></div>
          {/* </Modal.Footer> */}
        </div>
      </ModalSkeleton>
    </>
  );
};

export default BanExplanationModal;
